module.exports = __webpack_public_path__ + "static/media/slider-14.b34e22f6.jpg";